import { css } from '@emotion/react'
import { Theme } from '@mui/material'

export const layersTabParent = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  height: 100%;

  .bottom-shadow {
    margin-top: -4px;
    min-height: 4px;
    flex: 0;
    background: linear-gradient(
      to bottom,
      ${theme.palette.primary.dark}00 0%,
      ${theme.palette.primary.dark}10 100%
    );
    z-index: 1;
  }
`

export const mapLayerHeader = (theme: Theme) => css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
  padding-right: 16px;

  span {
    color: ${theme.palette.primary.dark};
    font-size: 18px;
    font-weight: 600;
    padding: 8px;
  }
`

export const layerOrganizerContainer = css`
  padding: 8px 16px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`

export const hazardControlToggle = (theme: Theme) => css`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  color: ${theme.palette.uintel.light};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`
